import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetPlannedTaskRemark = function (taskId, taskLevel, scheduleHasRemark, enabled) {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.Remark, taskId], function () {
        var scheduleRemarkPromise = scheduleHasRemark
            ? api.base.get("".concat(config.appUrls.tasks, "/api/taskschedules/Remark/").concat(taskId))
            : Promise.resolve({ data: null });
        var taskRemarkPromise = api.base.get("".concat(config.appUrls.tasks, "/api/plannedTasks/Remark/").concat(taskId, "?taskLevel=").concat(taskLevel));
        return Promise.all([
            taskRemarkPromise,
            scheduleRemarkPromise,
        ]).then(function (_a) {
            var remark = _a[0].data, scheduleRemark = _a[1].data;
            return ({ remark: remark, scheduleRemark: scheduleRemark });
        });
    }, {
        enabled: enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
